import classNames from 'classnames'
import React, { ReactNode } from 'react'
import styles from './FormSelectItem.module.css'

interface Props extends React.LiHTMLAttributes<HTMLLIElement> {
  children: ReactNode
}

export const FormSelectItem = ({ children, className, ...props }: Props) => {
  return (
    <li
      className={classNames(styles.li, 'hover-aa-supported', className)}
      role="option"
      aria-selected={props['aria-selected']}
      {...props}
    >
      {children}
    </li>
  )
}
